import _ from 'lodash'
import {
  FETCH_CONTACTS,
  FETCH_CONTACT,
  CREATE_CONTACT,
  DELETE_CONTACT,
  SEARCH_CONTACTS,
  FETCH_CONTACT_FIELDS,
  FETCH_LOG_CONTACT
} from 'Constants/actionTypes'

const INIT_STATE = {
  data: [],
  results: [],
  fields: [],
  current: {},
  currentLog: {},
  pagination: {}
}

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case FETCH_CONTACTS:
      let response = action.payload.data
      let pagination = action.payload.pagination
      return { ...state, data: response, pagination }
    case FETCH_CONTACT:
      response = action.payload.data
      return { ...state, current: response }
    case FETCH_LOG_CONTACT:
      response = action.payload.data
      return { ...state, currentLog: response }
    case SEARCH_CONTACTS:
      response = action.payload.data
      return { ...state, results: response }
    case CREATE_CONTACT:
      response = action.payload.data
      return { ...state, data: [response, ...state.data] }
    case FETCH_CONTACT_FIELDS:
      response = action.payload.data
      return { ...state, fields: response }
    case DELETE_CONTACT:
      return { ...state, data: _.reject(state.data, { id: action.payload }) }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/contacts.js